// @flow

import { type Merchant } from './types';

export function getFacebookPixelIds(merchant: Merchant): ImmutableArray<string> {
  return merchant['facebook_pixel_ids'] || [];
}
